(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["summer-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-sc-product-inquiry]');
    roots.forEach((root) => {
      const date = root.querySelector('[data-sc-inquiry-date]');
      const pax = root.querySelector('[data-sc-inquiry-pax]');
      const packageField = root.querySelector('[data-sc-inquiry-package]');
      const budget = root.querySelector('[data-sc-inquiry-budget]');
      const links = root.querySelectorAll('[data-sc-whatsapp-link]');
      const updateLinks = () => {
        const packageText = packageField?.selectedOptions?.[0]?.textContent?.trim() || packageField?.value || 'Not selected';
        const lines = [
          'Hello Summer Charter, I would like to check availability.',
          '',
          `Product: ${root.dataset.productTitle}`,
          `Date: ${date?.value || 'Not selected'}`,
          `Guests / Pax: ${pax?.value || 'Not selected'}`,
          `Package / Occasion: ${packageText}`
        ];
        if (budget) lines.push(`Budget: ${budget.value}`);
        lines.push('Language: English / 中文');
        const href = `https://wa.me/60195328077?text=${encodeURIComponent(lines.join('\n'))}`;
        links.forEach((link) => { link.href = href; });
      };
      [date, pax, packageField, budget].filter(Boolean).forEach((field) => {
        field.addEventListener('input', updateLinks);
        field.addEventListener('change', updateLinks);
      });
      links.forEach((link) => {
        link.addEventListener('click', () => {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'whatsapp_inquiry', product_name: root.dataset.productTitle });
        });
      });
      updateLinks();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
